import dynamic from "next/dynamic";

export const DynamicHeaderAvatar = dynamic(() =>
  import("~/components/home/header/header-avatar").then(module => module.HeaderAvatar),
);

export const DynamicHomeNewsTicker = dynamic<Record<string, never>>(() =>
  import("~/components/home/news-ticker").then(module => module.HomeNewsTicker),
);
